import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import API from "../axios";

interface GalleryPasteTableProps {
    vehicleId: string;
    fromVariantId?: string;
}

const GalleryPasteTable = (props: GalleryPasteTableProps) => {
    const [page, setPage] = useState(0);
    const [limit] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [pasteLoading, setPasteLoading] = useState(false);
    const [pastedIds, setPastedIds] = useState<string[]>([]);

    const loadVehicleVariants = async () => {
        const query = {
            page: page + 1,
            limit,
            vehicle: props.vehicleId,
        };

        setLoading(true);
        try {
            const result: any = await API.paginateVehicleVariants(query);
            setVehicles(result.data);
            setTotalPages(result.pagination.totalPages);
            setTotalItems(result.pagination.total);
        } catch (error) {
            console.log("Failed to load vehicles: ", error);
        } finally {
            setLoading(false);
        }
    };

    const goToPage = (newPage: number) => {
        if (newPage < 1 || newPage > totalPages) return;

        // Convert to 0-based indexing for internal state
        setPage(newPage - 1);
    };

    const handlePasteGallery = async (toVariantId: string) => {
        if (!props.fromVariantId) {
            return false;
        }

        setPasteLoading(true);
        try {
            let response = await API.copyVariantGallery(
                props.fromVariantId,
                toVariantId
            );
            console.log("Response: ", response);
            setPastedIds([...pastedIds, toVariantId]);

            console.log("Response: ", response);
        } catch (error) {
            console.log("error: ", error);
            console.log(error);
        }
        setPasteLoading(false);
    };

    // Load data whenever page changes
    useEffect(() => {
        loadVehicleVariants();
    }, [page]); // Add page as dependency

    // Initial load
    useEffect(() => {
        loadVehicleVariants();
    }, []);

    return (
        <div>
            <Container>
                <Row>
                    {loading ? (
                        <div
                            className="d-flex justify-content-center my-5"
                            style={{ minHeight: "100vh" }}
                        >
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </div>
                        </div>
                    ) : (
                        <table className="table mt-3">
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Variant</th>
                                    <th>OdooId</th>
                                    <th>Paste</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vehicles.map((vehicle, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img
                                                src={
                                                    vehicle.productImage ||
                                                    "/images/no-image.png"
                                                }
                                                width={80}
                                                height={60}
                                                className="rounded-2"
                                            />
                                        </td>
                                        <td className="fw-normal">
                                            {vehicle.productAttributes.map(
                                                (productAttribute: any) => (
                                                    <div className="badge bg-primary mx-1">
                                                        {`${productAttribute.attributeName} : ${productAttribute.attributeValueName}`}
                                                    </div>
                                                )
                                            )}
                                        </td>
                                        <td>
                                            <p>{vehicle.odooId}</p>
                                        </td>
                                        <td>
                                            <div className="d-grid gap-2 d-flex flex-row">
                                                <button
                                                    className={`btn ${
                                                        pastedIds.includes(
                                                            vehicle._id
                                                        )
                                                            ? "bg-primary"
                                                            : "btn-ligh"
                                                    }t mx-1 d-flex align-items-center justify-content-center`}
                                                    style={{
                                                        width: "36px",
                                                        height: "36px",
                                                        borderRadius: "50%",
                                                    }}
                                                    onClick={() =>
                                                        handlePasteGallery(
                                                            vehicle._id
                                                        )
                                                    }
                                                >
                                                    <i
                                                        className={`bi  ${
                                                            pastedIds.includes(
                                                                vehicle._id
                                                            )
                                                                ? "bi-check-circle"
                                                                : "bi-clipboard-check"
                                                        }`}
                                                    ></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {/* Updated Pagination */}
                    <nav
                        aria-label="Page navigation"
                        style={{ marginBottom: 200 }}
                    >
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                Showing{" "}
                                {vehicles.length > 0 ? page * limit + 1 : 0} to{" "}
                                {Math.min((page + 1) * limit, totalItems)}
                                of {totalItems} variants
                            </div>
                            <ul className="pagination">
                                <li
                                    className={`z-0 page-item ${
                                        page === 0 ? "disabled" : ""
                                    }`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => goToPage(1)}
                                        disabled={page === 0}
                                    >
                                        First
                                    </button>
                                </li>
                                <li
                                    className={`z-0 page-item ${
                                        page === 0 ? "disabled" : ""
                                    }`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => goToPage(page)}
                                        disabled={page === 0}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {/* Page numbers - show up to 5 around current page */}
                                {totalPages > 0 &&
                                    Array.from(
                                        { length: Math.min(5, totalPages) },
                                        (_, i) => {
                                            const currentPage = page + 1; // Convert to 1-based for display
                                            let pageNum: number;
                                            if (totalPages <= 5) {
                                                pageNum = i + 1;
                                            } else if (currentPage <= 3) {
                                                pageNum = i + 1;
                                            } else if (
                                                currentPage >=
                                                totalPages - 2
                                            ) {
                                                pageNum = totalPages - 4 + i;
                                            } else {
                                                pageNum = currentPage - 2 + i;
                                            }

                                            return (
                                                <li
                                                    key={i}
                                                    className={`z-0 page-item ${
                                                        currentPage === pageNum
                                                            ? "active"
                                                            : ""
                                                    }`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() =>
                                                            goToPage(pageNum)
                                                        }
                                                    >
                                                        {pageNum}
                                                    </button>
                                                </li>
                                            );
                                        }
                                    )}

                                <li
                                    className={`z-0 page-item ${
                                        page >= totalPages - 1 ? "disabled" : ""
                                    }`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => goToPage(page + 2)}
                                        disabled={page >= totalPages - 1}
                                    >
                                        Next
                                    </button>
                                </li>
                                <li
                                    className={`z-0 page-item ${
                                        page >= totalPages - 1 ? "disabled" : ""
                                    }`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => goToPage(totalPages)}
                                        disabled={page >= totalPages - 1}
                                    >
                                        Last
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </Row>
            </Container>
        </div>
    );
};

export default GalleryPasteTable;
